import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import IconButton from '../components/IconButton.jsx';
import Logo from '../images/logo.png';
import { ICON_BUTTON_TYPE } from '../constants/index.js';
import useStore, { updateScreenWidth } from '../Store/Store.js';
import { useTranslation } from 'react-i18next';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import HealthOverviewIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import Person2Icon from '@mui/icons-material/Person2';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import HomeIcon from '@mui/icons-material/Home';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

import { Dialog, Slide } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const width = useStore((state) => state.screenWidth);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { t } = useTranslation();
  const CAN_CARE_LIST = [
    { icon: <HomeIcon />, title: t('dashboard'), path: '/main' },
    { icon: <HealthOverviewIcon />, title: t('healthOverview'), path: '/health-overview' },
    { icon: <CalendarMonthIcon />, title: t('calenders'), path: '/calendar' },
    { icon: <RestaurantIcon />, title: t('nutritionAnalysis'), path: '/nutrition-analysis' },
    { icon: <MedicalServicesIcon />, title: t('pillReminder'), path: '/medications' },
    { icon: <LocalHospitalIcon />, title: t('doctorVisit'), path: '/doctor-visit' },
    { icon: <PeopleIcon />, title: t('careTeam'), path: '/caregivers' },
    { icon: <VolunteerActivismIcon />, title: t('careRecipients'), path: '/care-recipients' },
    { icon: <WarningIcon />, title: t('canEmergency'), path: '/can-emergency' },
    { icon: <ChatIcon />, title: t('chats'), path: '/chats' },
    { icon: <Person2Icon />, title: t('myProfile'), path: '/edit-profile' },
    { icon: <VideoSettingsIcon />, title: t('canVideos'), path: '/can-videos' },
  ];

  const isMobile = width < 850;

  const handleClickNav = (path) => {
    setSidebarOpen(false);
    navigate(path);
  };

  useEffect(() => {
    const handleResize = () => updateScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    updateScreenWidth(window.innerWidth); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const SidebarContent = ({ mobile = false }) => (
    <div
      className="sidebar"
      style={{
        width: mobile ? '100%' : width > 1350 ? '100%' : '40px',
        height: mobile ? '100vh' : width > 1350 ? '100vh' : 'auto',
        display: mobile ? 'flex' : width > 850 ? 'flex' : 'none',
      }}
    >
      <div className="frame" style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div className="frame-1">
            <img src={Logo} className="mask-group" alt="logo" />
          </div>
          {mobile && (
            <div className="frame-1">
              <IconButton type={ICON_BUTTON_TYPE.close} onClick={() => setSidebarOpen(false)} />
            </div>
          )}
        </div>

        <div className="frame-2">
          {CAN_CARE_LIST.map(({ icon, title, path }, idx) => (
            <div
              className="component-5"
              style={{
                background: location.pathname === path ? '#f5f5f7' : '#fff',
                width: mobile ? '80%' : width > 1350 ? '180px' : '38px',
              }}
              key={idx}
              onClick={() => handleClickNav(path)}
            >
              <div
                className="navbar-icon"
                style={{
                  background: location.pathname === path ? '#277769' : '#f5f5f7',
                  color: location.pathname === path ? '#fff' : 'grey',
                }}
              >
                {icon}
              </div>
              {(width > 1350 || mobile) && <span className="label-health-overview">{title}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {!isMobile && <SidebarContent />}
      {isMobile && (
        <>
          <IconButton type={ICON_BUTTON_TYPE.menu} style={{ margin: '10px' }} onClick={() => setSidebarOpen(true)} />
          <Dialog
            fullScreen
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            TransitionComponent={Transition}
            sx={{
              width: '60%',
            }}
          >
            <SidebarContent mobile />
          </Dialog>
        </>
      )}
    </>
  );
};

export default SideBar;
